<template>
  <transition name="cookies">
    <div class="cookies" v-if="!$store.getters.cookies">
      <div class="cookies__text">
        {{ui.cookies_text}}
        <router-link :to="'/'+ui.cookies_slug" v-text="ui.cookies_notice"
        />.
      </div>
      <div class="cookies__agree more" @click="agree">
        <span class="more__text" v-text="ui.cookies_agree" />
        <i class="more__arrow" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Appcookiess',
  computed: {
    ...mapGetters(['ui'])
  },
  data() {
    return {}
  },
  methods: {
    agree() {
      this.$store.dispatch('agreeToCookies')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/partials/AppCookies.vue